module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group has-feedback",
    class: [_vm.problems ? 'has-error' : '', _vm.cssClass]
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.label),
      expression: "label"
    }],
    staticClass: "control-label",
    attrs: {
      "for": _vm.field
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.problems && _vm.label && _vm.showIcon),
      expression: "problems && label && showIcon"
    }],
    staticClass: "glyphicon glyphicon-remove form-control-feedback",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.problems),
      expression: "problems"
    }],
    staticClass: "help-block"
  }, _vm._l((_vm.problems), function(problem) {
    return _c('p', {
      key: _vm.problems.indexOf(problem)
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.problems.length > 1),
        expression: "problems.length > 1"
      }],
      staticClass: "fa fa-exclamation",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n        " + _vm._s(problem) + "\n      ")])
  }), 0)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49b96d05","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/field-validation/index.vue
// module id = MuUL
// module chunks = 5